<template>
    <v-card>
        <v-stepper v-model="step" style="box-shadow: none;">
            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-card-title>
                        <h1>Novo {{ posto ? 'Posto' : 'Empresa' }}</h1>
                    </v-card-title>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs12>
                                Nome Fantasia: <b>{{contratante.nome_fantasia}}</b>
                            </v-flex>
                            <v-flex xs12>
                                Razão Social: <b>{{contratante.razao_social}}</b>
                            </v-flex>
                            <v-flex xs12>
                                CNPJ: <b>{{contratante.cnpj}}</b>
                            </v-flex>
                            <v-flex xs12 v-if="!postoSemRepresentante">
                                Contato: <b>{{posto ? contratante.representante.telefone : contratante.administrador.telefone}}</b>
                            </v-flex>
                            <v-flex xs12 v-if="!postoSemRepresentante">
                                Nome do Representante: <b>{{posto ? contratante.representante.nome : contratante.administrador.nome}}</b>
                            </v-flex>
                            <v-flex xs12 v-if="!postoSemRepresentante">
                                E-mail: <b>{{posto ? contratante.representante.email : contratante.administrador.email}}</b>
                            </v-flex>
                            <v-flex v-else class="info--text">
                                <b>Cadastrado por Automação</b>
                            </v-flex>
                            <v-flex xs12 v-if="contratante.tipo_empresa">
                                Tipo de Empresa: <b class="info--text">{{
                                    tipos_empresa[contratante.tipo_empresa]
                                }}</b>
                            </v-flex>
                            <v-flex xs12 class="mt-2" v-if="contratante.endereco">
                                <h3 style="text-align: center; width: 100%;">Endereço</h3>
                            </v-flex>
                            <v-flex xs6 v-if="contratante.endereco">
                                Logradouro: <b>{{contratante.endereco.logradouro}}</b>
                            </v-flex>
                            <v-flex xs6 v-if="contratante.endereco">
                                Número: <b>{{contratante.endereco.numero}}</b>
                            </v-flex>
                            <v-flex xs6 v-if="contratante.endereco">
                                Bairro: <b>{{contratante.endereco.bairro}}</b>
                            </v-flex>
                            <v-flex xs6 v-if="contratante.endereco">
                                Cidade: <b>{{contratante.endereco.cidade}}</b>
                            </v-flex>
                            <v-flex xs6 v-if="contratante.endereco">
                                Estado: <b>{{contratante.endereco.estado}}</b>
                            </v-flex>
                            <v-flex xs6 v-if="contratante.endereco">
                                CEP: <b>{{contratante.endereco.cep}}</b>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-stepper-content>
                <v-stepper-content step="2">
                    <v-card-title>
                        <h2>Definir Contrato  {{ posto ? 'do Posto' : 'da Empresa' }}</h2>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap justify-space-around fill-height v-if="!this.posto">
                            <v-flex xs12>
                            <v-switch
                                v-model="tem_mensalidade"
                                label="Tem assinatura"
                                color="primary"
                            ></v-switch>
                            </v-flex>
                            <v-flex xs12 v-if="tem_mensalidade">
                            <v-text-field
                                v-model.lazy="valor_mensalidade"
                                v-money="money"
                                v-if="rendering"
                                prefix="R$"
                                outline
                                label="Valor da assinatura"
                                hide-details
                            ></v-text-field>
                            <h5>Será combrado R$ {{contratante.valor_assinatura}} todos os meses da empresa {{contratante.nome_fantasia}}</h5>
                            </v-flex>
                            <v-flex xs12>
                            <v-switch
                                v-model="taxa_por_veiculo"
                                label="Tem taxa por veículo"
                                color="primary"
                            ></v-switch>
                            </v-flex>
                            <v-flex xs12 v-if="taxa_por_veiculo">
                            <v-text-field
                                v-model.lazy="valor_taxa_veiculo"
                                v-money="money"
                                v-if="rendering"
                                prefix="R$"
                                outline
                                label="Taxa por veículo"
                                hide-details
                            ></v-text-field>
                            <h5>Será combrado R$ {{contratante.taxa_por_veiculo}} por veículo da empresa {{contratante.nome_fantasia}}</h5>
                            </v-flex>
                            <v-flex xs12>
                            <v-switch
                                v-model="taxa_abastecimeto"
                                label="Tem percentual em cima do abastecimento"
                                color="primary"
                            ></v-switch>
                            </v-flex>
                            <v-flex xs12 v-if="taxa_abastecimeto">
                            <v-text-field
                                v-model="contratante.taxa_por_abastecimento"
                                v-if="rendering"
                                suffix="%"
                                outline
                                label="Taxa por abastecimetno"
                                hide-details
                                type="number"
                            ></v-text-field>
                            <h5>Será combrado {{contratante.taxa_por_abastecimento}}% por abastecimento da empresa {{contratante.nome_fantasia}}</h5>
                            </v-flex>
                            <v-btn
                                class="mt-3"
                                block
                                color="success"
                                @click="editarEmpresa"
                                :loading="loading"
                            >
                                <v-icon class="mr-1">save</v-icon>
                                Salvar
                            </v-btn>
                        </v-layout>
                        <v-layout row wrap justify-space-around fill-height v-else>
                            <v-flex xs12 v-if="contratante.programa_incentivo">
                            <v-switch
                                v-model="contratante.programa_incentivo.ativo_apetrus"
                                label="Programa de incentivo do frentista"
                                color="primary"
                            ></v-switch>
                            </v-flex>
                            <v-flex xs12 v-if="contratante.programa_incentivo && contratante.programa_incentivo.ativo_apetrus">
                            <v-text-field
                                v-model="percentual_incentivo"
                                v-if="rendering"
                                outline
                                label="Percentual incentivo do frentista"
                                hide-details
                                type="number"
                                suffix="%"
                            ></v-text-field>
                            <h5>Em uma compra com valor de 10 reias, será dado R$ {{valor_incentivo}}</h5>
                            </v-flex>
                            <v-flex xs12 v-if="contratante.programa_doacao">
                            <v-switch
                                v-model="contratante.programa_doacao.ativo_apetrus"
                                label="Programa de doação"
                                color="primary"
                            ></v-switch>
                            </v-flex>
                            <v-flex xs12 v-if="contratante.programa_doacao && contratante.programa_doacao.ativo_apetrus">
                            <v-text-field
                                v-model="percentual_doacao"
                                v-if="rendering"
                                outline
                                label="Percentual doacão"
                                hide-details
                                type="number"
                                suffix="%"
                            ></v-text-field>
                            <h5>Em uma compra com valor de 10 reias, será dado R$ {{valor_doado}}</h5>
                            </v-flex>
                            <v-flex xs12>
                            <v-switch
                                v-model="tem_taxa_empresa"
                                label="Tem taxa de abastecimento por empresa"
                                color="primary"
                            ></v-switch>
                            </v-flex>
                            <v-flex xs12 v-if="tem_taxa_empresa">
                            <v-text-field
                                v-model="taxa_empresa"
                                v-if="rendering"
                                outline
                                label="Taxa de abastecimento por empresa"
                                hide-details
                                type="number"
                                suffix="%"
                            ></v-text-field>
                            <h5>Em cada abastecimento {{taxa_empresa}}% pertence a Apetrus.</h5>
                            </v-flex>
                            <v-flex xs12>
                            <v-switch
                                v-model="tem_valor_mensal_fatura"
                                label="Tem mensalidade"
                                color="primary"
                            ></v-switch>
                            </v-flex>
                            <v-flex xs12 v-if="tem_valor_mensal_fatura">
                            <v-text-field
                                v-model.lazy="valor_mensal_fatura"
                                v-if="rendering"
                                outline
                                label="Mensalidade"
                                v-money="moneyPosto"
                                hide-details
                            ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                            <v-switch
                                v-model="tem_taxa_por_abastecimento"
                                label="Tem taxa por abastecimento"
                                color="primary"
                            ></v-switch>
                            </v-flex>
                            <v-flex xs12 v-if="tem_taxa_por_abastecimento">
                            <v-text-field
                                v-model="taxa_por_abastecimento"
                                v-if="rendering"
                                outline
                                label="Taxa por abastecimento"
                                hide-details
                                type="number"
                                suffix="%"
                            ></v-text-field>
                            </v-flex>
                            <v-btn
                                class="mt-4"
                                block
                                color="success"
                                @click="atualizarPosto"
                                :loading="loading"
                            >
                                <v-icon class="mr-1">save</v-icon>
                                Salvar
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        <v-card-actions class="justify-space-around">
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        icon
                        @click="$emit('fechar')"
                        v-on="on"
                    >
                            <v-icon color="error">close</v-icon>
                    </v-btn>
                </template>
                <span>Fechar</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        icon
                        @click="ativarOuDesativar"
                        v-on="on"
                    >
                            <v-icon color="success">{{ ativo ? 'highlight_off' : 'check_circle_outline' }}</v-icon>
                    </v-btn>
                </template>
                <span>{{ ativo ? `Desativar ${posto ? 'Posto' : 'Empresa'}` : `Ativar ${posto ? 'Posto' : 'Empresa'}` }}</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="marcarComoVisto">
                        <v-icon color="primary">visibility_off</v-icon>
                    </v-btn>
                </template>
                <span>Não ver mais</span>
            </v-tooltip>
            <v-tooltip bottom v-if="step==1">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="step++">
                        <v-icon color="info">description</v-icon>
                    </v-btn>
                </template>
                <span>Alterar contrato com {{posto ? 'Posto' : 'Empresa'}}</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="step = 1">
                        <v-icon color="info">arrow_back</v-icon>
                    </v-btn>
                </template>
                <span>Voltar</span>
            </v-tooltip>
        </v-card-actions>
    </v-card>
</template>

<script>
import { postoDao } from '@/api'
import { VMoney } from 'v-money'
export default {
    props: ['object'],
    directives: { money: VMoney },
    data: () => ({
        contratante: null,
        ativo: false,
        step: 1,
        posto: false,
        taxa_abastecimeto: false,
        taxa_por_veiculo: false,
        valor_taxa_veiculo: null,
        tem_mensalidade: false,
        valor_mensalidade: null,
        percentual_doacao: 0,
        percentual_incentivo: 0,
        valor_mensal_fatura: null,
        tem_valor_mensal_fatura: false,
        taxa_empresa: null,
        tem_taxa_empresa: false,
        tem_taxa_por_abastecimento: false,
        taxa_por_abastecimento: null,
        valor_doado: '0,00 centavos',
        valor_incentivo: '0,00 centavos',
        rendering: true,
        postoSemRepresentante: false,
        tipos_empresa: {
            1: 'Frota de Veículos',
            2: 'Revendedora de Veículos',
            3: 'Automação',
            4: 'Venda de Produtos',
            5: 'Prestação de Serviços',
            6: 'Venda de Produtos e Serviços',
            7: 'Instituição Beneficente',
            8: 'Integradora'
        },
         money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            precision: 2,
            masked: false
        },
        moneyPosto: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            precision: 2,
            masked: false
        }
    }),
    computed: {
        loading () {
            return this.$store.getters.loading
        },
        headers () {
            return this.$store.getters.headers
        }
    },
    beforeMount () {
        this.posto = this.object.representante === null || !!this.object.representante
        this.postoSemRepresentante = this.object.representante === null
        this.contratante = this.object
        this.ativo = this.contratante.ativo
        if (this.posto) {
            this.prepararPosto()
        } else this.prepararInterfaceEmpresa()
    },
    watch: {
        valor_taxa_veiculo (val) {
            if (val !== undefined && val !== null) {
                this.contratante.taxa_por_veiculo = val.replace(',', '.')
            }
        },
        valor_mensalidade (val) {
            if (val !== undefined && val !== null) {
                this.contratante.valor_assinatura = val.replace(',', '.')
            }
        },
        taxa_abastecimeto (val) {
            if (!val) {
                this.contratante.taxa_por_abastecimento = null
            }
        },
        taxa_por_veiculo (val) {
            if (!val) {
                this.contratante.taxa_por_veiculo = null
                this.valor_taxa_veiculo = null
            }
        },
        tem_mensalidade (val) {
            if (!val) {
                this.contratante.valor_assinatura = null
                this.valor_mensalidade = null
            }
        },
        taxa_por_abastecimento (val) {
            this.contratante.taxa_por_abastecimento = val
        },
        percentual_doacao (val) {
        val = Number(val)
            if (val) {
                let valorCompra = 10
                let valorDoacao = (valorCompra * val) / 100
                this.contratante.programa_doacao.percentual = val
                this.valor_doado = `${valorDoacao.toFixed(2)} ${valorDoacao >= 1 ? 'reais' : 'centavos'}`
            }
        },
        tem_taxa_empresa (val) {
            if (!val) {
                this.taxa_empresa = null
                this.contratante.taxa_empresa = null
            }
        },
        tem_valor_mensal_fatura (val) {
            if (!val) {
                this.valor_mensal_fatura = null
                this.contratante.valor_fatura_mensal = null
            }
        },
        valor_mensal_fatura (val) {
            this.contratante.valor_fatura_mensal = val
        },
        tem_taxa_por_abastecimento (val) {
            if (!val) {
                this.taxa_por_abastecimento = null
                this.contratante.taxa_por_abastecimento = null
            }
        },
        taxa_empresa (val) {
            this.contratante.taxa_empresa = val
        },
        percentual_incentivo (val) {
            val = Number(val)
            if (val) {
                let valorCompra = 10
                let valorIncentivo = (valorCompra * val) / 100
                this.contratante.programa_incentivo.percentual = val
                this.valor_incentivo = `${valorIncentivo.toFixed(2)} ${valorIncentivo >= 1 ? 'reais' : 'centavos'}`
            }
        }
    },
    methods: {
        marcarComoVisto () {
            const data = {}
            data.id_empresa = !this.posto ? this.contratante.cnpj : null
            data.id_posto = this.posto ? this.contratante.cnpj : null
            this.$store.dispatch('marcarComoLido', data).then(() => {
                this.$emit('carregarNotificacoes')
                this.$emit('fechar')
            })
        },
        desativarPosto () {
            postoDao.desativarPosto(this.contratante.cnpj, this.headers).then(response => {
                if (response.ok) {
                    this.ativo = !this.ativo
                }
            })
        },
        ativarPosto () {
            postoDao.ativarPosto(this.contratante.cnpj, this.headers).then(response => {
                if (response.ok) {
                    this.ativo = !this.ativo
                }
            })
        },
        ativaOuDesativarEmpresa () {
            this.$store.dispatch('ativarOuDesativarEmpresa', this.contratante.cnpj).then(() => {
                this.ativo = !this.ativo
            })
        },
        ativarOuDesativar () {
            if (this.posto) {
                if (this.ativo) {
                    this.desativarPosto()
                } else this.ativarPosto()
            } else this.ativaOuDesativarEmpresa()
        },
        pegarEmpresa () {
            this.$store.dispatch('pegarEmpresa', this.contratante.cnpj).then(json => {
                this.contratante = json
                if (this.contratante.taxa_por_abastecimento !== null) {
                    this.taxa_abastecimeto = true
                }
                if (this.contratante.taxa_por_veiculo !== null) {
                    this.taxa_por_veiculo = true
                    this.valor_taxa_veiculo = this.contratante.taxa_por_veiculo
                }
                if (this.contratante.valor_assinatura !== null) {
                    this.tem_mensalidade = true
                    this.valor_mensalidade = this.contratante.valor_assinatura
                }
            })
        },
        prepararInterfaceEmpresa () {
            if (this.contratante.taxa_por_abastecimento !== null) {
                this.taxa_abastecimeto = true
            }
            if (this.contratante.taxa_por_veiculo !== null) {
                this.taxa_por_veiculo = true
                this.valor_taxa_veiculo = this.contratante.taxa_por_veiculo
            }
            if (this.contratante.valor_assinatura !== null) {
                this.tem_mensalidade = true
                this.valor_mensalidade = this.contratante.valor_assinatura
            }
        },
        editarEmpresa () {
            this.$store.dispatch('editarEmpresa', this.contratante).then(() => {
                this.pegarEmpresa()
                // this.$emit('success', 'Empresa atualizada com sucesso.')
                this.rendering = true
            }).catch(() => {
                this.$emit('error', 'Não foi possível atualizar empresa.')
            })
        },
        carregarPosto () {
            this.$store.dispatch('detalhesPosto', this.cnpj).then(json => {
                this.contratante = json
                this.valor_mensal_fatura = json.valor_fatura_mensal
                this.taxa_por_abastecimento = json.taxa_por_abastecimento
                this.taxa_empresa = json.taxa_empresa
                this.tem_taxa_empresa = this.taxa_empresa !== null
                this.tem_taxa_por_abastecimento = this.taxa_por_abastecimento !== null
                this.tem_valor_mensal_fatura = this.valor_mensal_fatura !== null
                this.rendering = false
                if (this.contratante.programa_incentivo === null) {
                    this.contratante.programa_incentivo = {
                        percentual: 1,
                        ativo_apetrus: false
                    }
                } else {
                    this.percentual_incentivo = this.contratante.programa_incentivo.percentual
                }
                if (this.contratante.programa_doacao === null) {
                    this.contratante.programa_doacao = {
                        percentual: 1,
                        ativo_apetrus: false
                    }
                } else {
                    this.percentual_doacao = this.contratante.programa_doacao.percentual
                }
                this.$nextTick(() => {
                    this.rendering = true
                })
            })
        },
        prepararPosto () {
            this.valor_mensal_fatura = this.contratante.valor_fatura_mensal
            this.taxa_por_abastecimento = this.contratante.taxa_por_abastecimento
            this.taxa_empresa = this.contratante.taxa_empresa
            this.tem_taxa_empresa = this.taxa_empresa !== null
            this.tem_taxa_por_abastecimento = this.taxa_por_abastecimento !== null
            this.tem_valor_mensal_fatura = this.valor_mensal_fatura !== null
            this.rendering = false
            if (this.contratante.programa_incentivo === null) {
                this.contratante.programa_incentivo = {
                    percentual: 1,
                    ativo_apetrus: false
                }
            } else {
                this.percentual_incentivo = this.contratante.programa_incentivo.percentual
            }
            if (this.contratante.programa_doacao === null) {
                this.contratante.programa_doacao = {
                    percentual: 1,
                    ativo_apetrus: false
                }
            } else {
                this.percentual_doacao = this.contratante.programa_doacao.percentual
            }
            this.$nextTick(() => {
                this.rendering = true
            })
        },
        atualizarPosto () {
            if (this.contratante.valor_fatura_mensal !== null) {
                this.contratante.valor_fatura_mensal = parseFloat(
                    this.valor_mensal_fatura.split(' ')[1]
                )
            }
            this.$store.dispatch('atualizarPosto', this.contratante).then(() => {
                this.$emit('success')
            })
        }
    }
}
</script>
